import { render } from "./humanityMuseumHome.vue?vue&type=template&id=2c1ae2f0&scoped=true"
import script from "./humanityMuseumHome.vue?vue&type=script&lang=js"
export * from "./humanityMuseumHome.vue?vue&type=script&lang=js"

import "./humanityMuseumHome.vue?vue&type=style&index=0&id=2c1ae2f0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1ae2f0"]])

export default __exports__